import { getAccessToken } from './client'

const apiBase = import.meta.env.VITE_API_BASE_URL ?? 'https://api.provisium.ru/api/v1'

type ClientErrorPayload = {
  message: string
  stack?: string
  component_stack?: string
  source?: string
  page_url?: string
  user_agent?: string
}

/** Fire-and-forget report to core `/client-errors` (public + optional JWT). */
export const reportClientError = (payload: ClientErrorPayload): void => {
  const body = JSON.stringify({
    message: payload.message.slice(0, 500),
    stack: payload.stack?.slice(0, 8000),
    component_stack: payload.component_stack?.slice(0, 8000),
    source: payload.source ?? 'market',
    page_url: payload.page_url ?? (typeof window !== 'undefined' ? window.location.href : undefined),
    user_agent:
      payload.user_agent ?? (typeof navigator !== 'undefined' ? navigator.userAgent : undefined),
  })

  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
  }
  const token = getAccessToken()
  if (token) {
    headers.Authorization = `Bearer ${token}`
  }

  void fetch(`${apiBase}/client-errors`, {
    method: 'POST',
    headers,
    body,
    keepalive: true,
  }).catch(() => {
    // ignore network failures — boundary already shows UI
  })
}
